import { Box, Button, HStack, IconButton, Modal, Stack, Text, VStack } from '@genial/components';
import { BoxBorder, Typography } from '@genial/design-tokens';
import { Modal as NativeModal } from 'native-base';
import React from 'react';
import { Dimensions } from 'react-native';

export interface SuitabilityExceedModalProps {
  isOpen: boolean;
  onClose: () => void;
  limitPoints: string;
  currentPoints: string;
  hasError?: boolean;
}

export const SuitabilityExceedModal: React.FC<SuitabilityExceedModalProps> = ({
  isOpen,
  onClose,
  limitPoints,
  currentPoints,
  hasError,
}) => {
  const { height } = Dimensions.get('window');

  const formatPoints = (points: string) => `${points} pontos`;

  return (
    <Modal isOpen={isOpen} onClose={onClose} testId="suitability-exceeded-details">
      <NativeModal.Content
        alignItems="center"
        w="full"
        maxH={{ base: height * 0.75, lg: '410px' }}
        maxW={{ base: 'full', lg: '475px' }}
        marginBottom={{ base: 0, lg: 'none' }}
        marginTop={{ base: 'auto', lg: 0 }}
        borderRadius={BoxBorder.heavy}>
        <VStack w="full" px="inline.xxs" py="inline.xs" space="stack.xxxs">
          <HStack justifyContent="space-between" w="full" alignItems="center">
            <Stack />
            <IconButton
              testId="icon-close"
              icon="CloseModal"
              iconSize="xs"
              borderWidth="1"
              variant="rounded"
              backgroundColor="transparent"
              iconColor="brand.primary.principal"
              borderColor="brand.primary.principal"
              onPress={onClose}
              p={0}
            />
          </HStack>

          <VStack w="full" px="inline.xxxs" space="stack.xxxs">
            <Text variant="semibold" color="neutral.black" textAlign="center" fontSize="lg">
              Limite de risco excedido.
            </Text>

            <Text color="bulletrisk.medium">
              O valor do investimento ultrapassa o limite de risco da carteira do cliente. Selecione
              outro cliente ou produto para continuar.
            </Text>

            <VStack px="inline.xs" space="stack.xxxs">
              <HStack alignItems="center" w="full" space="inline.quarck" mb="stack.xxxs">
                <Box flex={1} h="4px" borderRadius={BoxBorder.heavy} bg="bulletrisk.low" />
                <Box
                  h="18px"
                  borderLeftWidth="1px"
                  borderStyle="dashed"
                  borderColor="bulletrisk.medium"
                />
                <Box w="48px" h="4px" borderRadius={BoxBorder.heavy} bg="bulletrisk.high" />
              </HStack>

              <HStack alignItems="center" justifyContent="space-between" w="full">
                <HStack alignItems="center" space="inline.xxxs">
                  <Box
                    ml="6px"
                    h="18px"
                    w="7px"
                    borderLeftWidth="1px"
                    borderStyle="dashed"
                    borderColor="bulletrisk.medium"
                  />
                  <Text color="bulletrisk.medium">Limite de risco</Text>
                </HStack>

                <Text variant="semibold" color="bulletrisk.medium">
                  {hasError ? '--' : formatPoints(limitPoints)}
                </Text>
              </HStack>

              <HStack alignItems="center" justifyContent="space-between" w="full">
                <HStack alignItems="center" space="inline.xxxs">
                  <Box h="9px" w="13px" borderRadius={BoxBorder.heavy} bg="bulletrisk.high" />
                  <Text color="bulletrisk.medium">Risco atual da carteira</Text>
                </HStack>

                <Text variant="semibold" color="bulletrisk.medium">
                  {hasError ? '--' : formatPoints(currentPoints)}
                </Text>
              </HStack>
            </VStack>

            <Button
              mt="stack.xxxs"
              w="full"
              borderRadius="full"
              variant="primary"
              onPress={onClose}
              _text={{
                fontFamily: Typography['fontfamily.base.semibold'],
                textTransform: 'uppercase',
                letterSpacing: 1,
              }}>
              Entendi
            </Button>
          </VStack>
        </VStack>
      </NativeModal.Content>
    </Modal>
  );
};
